module.exports = __webpack_public_path__ + "static/media/login-background.eeb59240.png";